import { cn } from '@/lib/utils'
import { eventChipStyle, shortLabelFor } from '@/types/equipment'

/** A single color-coded event-type badge used in cycle cells. */
export function EventTypeChip({
  code,
  label,
  color,
  short,
  className,
}: {
  code: string
  label: string
  color: string
  /** Render the compact short label instead of the full label. */
  short?: boolean
  className?: string
}) {
  return (
    <span
      title={label}
      style={eventChipStyle(color)}
      className={cn(
        'inline-flex items-center rounded-md px-2 py-1 text-[10px] font-semibold leading-none shadow-sm',
        className,
      )}
    >
      {short ? shortLabelFor(code, label) : label}
    </span>
  )
}
